@if (icon) {
<icon [icon]="icon" [class]="iconsize + ' ' + iconcolor"></icon>
}

<h3 class="mt-0">{{ title }}</h3>
<ng-content></ng-content>
